import { getProxySessionToken } from '../config/proxySessionToken';

/** Nagłówki upload/delete na home.pl — token sesji zamiast REACT_APP_PROXY_TOKEN. */
export function getHomePlProxyHeaders(contentTypeJson = false) {
  const sessionToken = getProxySessionToken();
  if (sessionToken) {
    return contentTypeJson
      ? { 'X-Proxy-Token': sessionToken, 'Content-Type': 'application/json' }
      : { 'X-Proxy-Token': sessionToken };
  }
  const direct = process.env.REACT_APP_DIRECT_UPLOAD_TOKEN;
  if (direct) {
    return contentTypeJson
      ? { 'X-Upload-Token': direct, 'Content-Type': 'application/json' }
      : { 'X-Upload-Token': direct };
  }
  return contentTypeJson ? { 'Content-Type': 'application/json' } : {};
}
